function footerAccordion() {
  let accordions = document.querySelectorAll('.footer-block--menu .footer-block__heading');

  if(!accordions.length) return;

  accordions.forEach(accordion => {
    accordion.addEventListener('click', function(){
      this.classList.toggle('active');
      this.nextElementSibling.classList.toggle('is-selected');
    });
  });
}

function showMenuOnHover() {
  let items = document.querySelectorAll('.header__inline-menu summary.header__menu-item');

  if(!items) return;

  items.forEach(item => {
    let hasMouseOverOccurred = false;
    let parentDetails = item.parentElement;
    item.addEventListener('mouseover', function () {
      if (!hasMouseOverOccurred) {
        this.parentElement.setAttribute('open','')
      }
    });

    parentDetails.addEventListener('mouseleave', function () {
      hasMouseOverOccurred = false;
      this.removeAttribute('open');
    });
  });
}

function handleCollectionTabs(section) {
  const buttons = section.querySelectorAll(".collection-tabs button");
  const tabSection = section.querySelector(".collection-tab-section");

  if (!buttons.length || !tabSection) return;

  buttons.forEach(button => {
    button.addEventListener("click", function () {

      buttons.forEach(btn => btn.classList.remove("active"));

      this.classList.add("active");

      const targetId = this.getAttribute("data-id");
      if (!targetId) return;

      const allTabs = tabSection.querySelectorAll("slider-component");
      allTabs.forEach(tab => tab.classList.remove("is-selected"));

      const activeTab = tabSection.querySelector(`#tab-${targetId}`);
      if (activeTab) {
        activeTab.classList.add("is-selected");
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function(){
  footerAccordion();
  showMenuOnHover();
  
  document.querySelectorAll(".featured-collection-section").forEach(section => {
    handleCollectionTabs(section);
  });
});